import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var TRANSFORM_STYLE_PROPERTIES = ['perspective', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'skewX', 'skewY', 'translateX', 'translateY'];
export default function wrapStyleTransforms(style) {
  var wrapped = {};
  Object.keys(style).forEach(function (key) {
    if (TRANSFORM_STYLE_PROPERTIES.indexOf(key) !== -1) {
      if (!wrapped.transform) {
        wrapped.transform = [];
      }

      wrapped.transform.push(_defineProperty({}, key, style[key]));
    } else {
      wrapped[key] = style[key];
    }
  });
  return wrapped;
}

if (typeof wrapStyleTransforms !== 'undefined' && wrapStyleTransforms && wrapStyleTransforms === Object(wrapStyleTransforms) && Object.isExtensible(wrapStyleTransforms) && !wrapStyleTransforms.hasOwnProperty('__filemeta')) {
  Object.defineProperty(wrapStyleTransforms, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapStyleTransforms",
      filename: "node_modules/react-native-animatable/wrapStyleTransforms.js"
    }
  });
}